import { TestDataAssetsTab } from "../../../../components/test-data-assets-tab";

interface DataAssetsTabProps {
  testId: string;
}

export function DataAssetsTab({ testId }: DataAssetsTabProps) {
  return <TestDataAssetsTab testId={testId} />;
}
